import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";

import { selectWishlist }   from "../../../../redux/shop/selectors";
import { WishlistModal }    from "../Modal/WishlistModal";
import { ReactComponent as HeartIcon } from "../../../../icons/Heart.svg";
import { MenuStyled }       from "./Menu.styled";

const API_WISHLIST = `${process.env.REACT_APP_API_BASE_URL}/user/favorite-products`;

export const WishlistMenu = () => {
  const [isWishlistOpen, setIsWishlistOpen] = useState(false);

  const wishlistItemsRedux = useSelector(selectWishlist);

  const [items, setItems]   = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchWishlist = async () => {
      try {
        setLoading(true);
        const token = sessionStorage.getItem("accessToken");
        if (!token) return;

        const res = await axios.get(API_WISHLIST, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const arr = res.data?.productResponse ?? res.data ?? [];
        if (Array.isArray(arr)) setItems(arr);
      } catch (e) {
        console.error("Ошибка загрузки избранного:", e);
      } finally {
        setLoading(false);
      }
    };
    fetchWishlist();
  }, []);

  useEffect(() => {
    if (Array.isArray(wishlistItemsRedux) && wishlistItemsRedux.length)
      setItems(wishlistItemsRedux);
  }, [wishlistItemsRedux]);

  const totalItemsCount = items.length;

  useEffect(() => {
    const handleClick = (e) => {
      if (!e.target.closest('[name="wishlist"]')) setIsWishlistOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  return (
      <MenuStyled $quantity={totalItemsCount}>
        <button
            name="wishlist"
            type="button"
            aria-label="Open Wishlist Modal"
            onClick={() => setIsWishlistOpen((prev) => !prev)}
        >
          <HeartIcon />
        </button>

        {isWishlistOpen && (
            <WishlistModal onClick={() => setIsWishlistOpen(false)} />
        )}
      </MenuStyled>
  );
};
